import { PrismicPageParser } from "../../shared/utils/prismicPageParser"
import cx from "classnames"
import styles from "./GivingBackContainer.module.scss"

const GivingBackContainer = () => {
  const data = JSON.parse(window.prismic_data)
  const pageId = window.pageId

  return (
    <section
      id="mm-giving-back"
      className={cx(styles.givingBack, "pageContainer")}
      aria-label="Giving Back page"
    >
      <PrismicPageParser pageData={data} pageId={pageId} />
    </section>
  )
}

export default GivingBackContainer
